import SystemFeaturesList from '@/components/pricing/SystemFeaturesList';

import PricingWhatsIncludedSection from './PricingWhatsIncludedSection';

const PricingStep2Section = () => {
  return (
    <section className="px-6 md:px-20 pt-10 md:pt-20 bg-gradient-to-b from-alter-beige to-white">
      <div className="width-1440 flex flex-col gap-8 lg:flex-row lg:gap-20">
        <div className="flex flex-col gap-4 lg:w-1/3">
          <p className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-black text-white font-light text-2xl">
            2
          </p>
          <h2 className="font-light text-3.5xl lg:text-[42px] leading-snug">Choose your system</h2>
          <p className="font-light flex items-center gap-2 lg:text-lg text-alter-black-80">
            Choose the Alter System that fits you best: Alter Anywhere or Alter One. Both options
            use your DNA insights to create personalized workouts and nutrition plans tailored to
            your genetics, with real-time biometric tracking to guide your progress.
          </p>
        </div>
        <div className="flex flex-col gap-4 lg:gap-10 lg:w-2/3">
          <SystemFeaturesList />
          <PricingWhatsIncludedSection />
        </div>
      </div>
    </section>
  );
};

export default PricingStep2Section;
